<template>
  <div id="coach_info">
    <div class="con_all">
      <div class="con_box2">
        <div class="ca_title">
          <div class="ca_l">
            <span class="con_title con_title_line">{{className}} {{showPage.coach_info_title}}</span>
          </div>
          <div class="ca_l">
            <div class="ca_r">
              <router-link :to="{ name: 'class_item', params:{classname: className}}">
                <button class="ca_btn">{{showPage.class_item}}</button>
              </router-link>
            </div>
            <div class="ca_r2">
              <router-link :to="{ name: 'facility', params:{classname: className}}">
                <button class="ca_btn">{{showPage.facility}}</button>
              </router-link>
            </div>
            <div class="ca_r2">
              <router-link :to="{ name: 'class_inside', params:{classname: className}}">
                <button class="ca_btn">{{showPage.class_inside}}</button>
              </router-link>
            </div>
          </div>
          <div class="fix"></div>
        </div>
        <div class="coach_box" v-for="(coach,index) in coachs" :key="index">
          <div class="coach_l">
            <img :src="coach.profileImage" v-if="coach.profileImage">
            <img src="/../static/images/timeline-default-photo.gif" v-else>
          </div>
          <div class="coach_r">
            <ul>
              <li>{{showPage.name}} : {{showName(coach)}}</li>
              <li>{{showPage.sex}} : {{showSex(coach.sex)}}</li>
              <li>{{showPage.license}} : <span v-html="showLicense(coach)"></span></li>
              <li>{{showPage.history}} : <span v-html="showHistory(coach)"></span></li>
            </ul>
          </div>
          <div class="fix"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'coach_info',
  data() {
    return {
      classId: this.$route.params.classid,
      coachs: [],
      className: this.$route.params.classname,
      showPage: ShowPage(sessionStorage.getItem('locale'))
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initCoachs();
    },
    initCoachs() {
      this.getCoachsData();
    },
    getCoachsData() {
      axios.get(API.classcoach + `?classid=${this.classId}`)
        .then(response => {
          this.coachs = response.data;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },



    showName(coach) {
      return sessionStorage.locale === 'CH' ? coach.nameCh : coach.nameEn;
    },
    showSex(sex) {
      return sessionStorage.locale === 'CH' ? sex ? '男' : '女' : sex ? 'male' : 'Female';
    },
    showLicense(coach) {
      return sessionStorage.locale === 'CH' ? (coach.licenseCh) : (coach.licenseEn);
    },
    showHistory(coach) {
      return sessionStorage.locale === 'CH' ? (coach.historyCh) : (coach.historyEn);
    }
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// CoachInfo.vue?ac175a1c